export enum remoteDeviceStatus {
    Enabled = 1,
    Disabled = 2,
    Inactive = 3,
    Expired = 4,
}

export namespace remoteDeviceStatus {
    export function values() {
        return Object.keys(remoteDeviceStatus).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}

